import React from 'react'
import classnames from 'classnames'
import { createStructuredSelector } from 'reselect'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit } from '@fortawesome/pro-regular-svg-icons/faEdit'
import { faPlus } from '@fortawesome/pro-regular-svg-icons/faPlus'
import { faArrows } from '@fortawesome/pro-regular-svg-icons/faArrows'
import { faPlay } from '@fortawesome/pro-regular-svg-icons/faPlay'
import { faArrowsH } from '@fortawesome/pro-regular-svg-icons/faArrowsH'
import { connect, Selectors, Actions } from '@react-page/core/lib'
import { useConfig } from '@peracto/peracto-config'

import { Save, SaveAndIndex } from './Save'
import Export from './Export'

import { Buttons } from './styled'

const { editMode, insertMode, layoutMode, previewMode, resizeMode } = Actions.Display
const { isEditMode, isInsertMode, isLayoutMode, isPreviewMode, isResizeMode } = Selectors.Display

const Edit = connect(createStructuredSelector({ isEditMode }), { editMode })(
    ({ isEditMode, editMode }) => {
        return (
            <button
                title="Edit"
                className={classnames('btn', {
                    'btn-active': isEditMode,
                })}
                data-testid="content-edit"
                onClick={() => {
                    const el = document.getElementById('editor-content-body')
                    const position = el.scrollTop

                    editMode()

                    setTimeout(() => {
                        el.scrollTop = position
                    }, 200)
                }}
            >
                <FontAwesomeIcon icon={faEdit} />
            </button>
        )
    }
)

const Add = connect(createStructuredSelector({ isInsertMode }), { insertMode })(
    ({ isInsertMode, insertMode }) => {
        return (
            <button
                title="Add"
                className={classnames('btn', {
                    'btn-active': isInsertMode,
                })}
                data-testid="content-add"
                onClick={insertMode}
            >
                <FontAwesomeIcon icon={faPlus} />
            </button>
        )
    }
)

const Move = connect(createStructuredSelector({ isLayoutMode }), { layoutMode })(
    ({ isLayoutMode, layoutMode }) => {
        return (
            <button
                title="Move"
                className={classnames('btn', {
                    'btn-active': isLayoutMode,
                })}
                data-testid="content-move"
                onClick={() => {
                    const el = document.getElementById('editor-content-body')
                    const position = el.scrollTop

                    layoutMode()

                    setTimeout(() => {
                        el.scrollTop = position
                    }, 200)
                }}
            >
                <FontAwesomeIcon icon={faArrows} />
            </button>
        )
    }
)

const Preview = connect(createStructuredSelector({ isPreviewMode }), { previewMode })(
    ({ isPreviewMode, previewMode }) => {
        return (
            <button
                title="Preview"
                className={classnames('btn', {
                    'btn-active': isPreviewMode,
                })}
                data-testid="content-preview"
                onClick={previewMode}
            >
                <FontAwesomeIcon icon={faPlay} />
            </button>
        )
    }
)

const Resize = connect(createStructuredSelector({ isResizeMode }), { resizeMode })(
    ({ isResizeMode, resizeMode }) => {
        return (
            <button
                title="Resize"
                className={classnames('btn', {
                    'btn-active': isResizeMode,
                })}
                data-testid="content-resize"
                onClick={resizeMode}
            >
                <FontAwesomeIcon icon={faArrowsH} />
            </button>
        )
    }
)

const Toolbar = ({ onSave, contentId }) => {
    const config = useConfig()
    const { content } = config.get('features', {})
    return (
        <Buttons>
            <Edit />
            <Add />
            <Resize />
            <Move />
            <Preview />
            {contentId && <Export contentId={contentId} />}
            {content?.indexContent ? <SaveAndIndex onSave={onSave} /> : <Save onSave={onSave} />}
        </Buttons>
    )
}

export default Toolbar
